/* Sweat Defender Crew bundle builder (2.0 shirt).
   The page edits a DRAFT of the cart. On load it reads /cart.js and copies the
   2.0 lines into the draft. Taps change the draft only. Checkout writes the
   draft to the cart in one pass (quantity changes and removals through
   /cart/update.js, new variants through /cart/add.js) and opens checkout.
   Done and the back arrow leave without writing; when the draft differs from
   the cart a centered "Leave without saving?" pop-up asks first (Keep editing,
   the dimmed page or Esc stay; Leave without saving goes back).
   The size row applies to shirts added on this page. Shirts that came in
   from the cart keep their size whatever is tapped (each draft line carries
   `base`, the quantity that came from the cart; only the rest moves when the
   size changes). The row preselects the first cart shirt's size.
   Arriving from the homepage: ?add=<variant id>&goal=<n> puts that shirt in
   the DRAFT (not the cart) as the first line, sets its size, and lights the
   tier for n shirts as the goal until the bundle reaches it. The parameters
   are removed from the address once read, so a reload does not add it again.
   Prices: the ladder is a fixed USD amount off each shirt, charged by the
   store's automatic discounts (not codes). The page shows the shirt's local
   price minus the USD amount converted at the rate Shopify prints on every
   page (window.Shopify.currency.rate), with the gift-card fallback the Classic
   builder uses. */
(function () {
  'use strict';
  if (window.customElements.get('bundle-builder-2')) return;

  var fmtCache = {};
  function money(amount, currency) {
    var key = currency || 'USD';
    if (!fmtCache[key]) {
      try { fmtCache[key] = new Intl.NumberFormat('en-US', { style: 'currency', currency: key }); }
      catch (e) { fmtCache[key] = { format: function (n) { return '$' + Number(n).toFixed(2); } }; }
    }
    return fmtCache[key].format(amount);
  }
  function minorDigits(currency) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }).resolvedOptions().maximumFractionDigits; } catch (e) { return 2; }
  }
  function roundMinor(n, digits) { var f = Math.pow(10, digits); return Math.round(n * f) / f; }
  function pctOff(price, base) { return Math.max(0, Math.floor((1 - price / base) * 100 / 5) * 5) + '%'; }
  function usd(n) { return '$' + (Number.isInteger(n) ? String(n) : n.toFixed(2)); }
  function fill(tpl, vars) { return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return k in vars ? vars[k] : m; }); }
  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function postJSON(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (res) { return res.json().catch(function () { return {}; }).then(function (data) { if (!res.ok) throw new Error(data.description || data.message || ('HTTP ' + res.status)); return data; }); });
  }

  function BundleBuilder2() { return Reflect.construct(HTMLElement, [], BundleBuilder2); }
  BundleBuilder2.prototype = Object.create(HTMLElement.prototype);
  BundleBuilder2.prototype.constructor = BundleBuilder2;

  BundleBuilder2.prototype.connectedCallback = function () {
    if (this._init) return;
    this._init = true;
    var self = this;
    try {
      this.config = JSON.parse(this.querySelector('[data-bb-config]').textContent);
      this.products = JSON.parse(this.querySelector('[data-bb-products]').textContent);
    } catch (e) { console.error('[bundle-builder-2] bad JSON', e); return; }
    this.text = this.config.text || {};
    this.routes = this.config.routes || {};
    this.currency = this.config.currency || 'USD';
    this.isUSD = this.currency === 'USD';

    var firstVariant = (this.products[0] || {}).variants;
    var baseLocal = (Number(this.config.baseLocal) || (firstVariant && firstVariant[0] && firstVariant[0].price) || 0) / 100;
    this.basePrice = baseLocal > 0 ? baseLocal : 59.99;
    var adj = 1 + (Number(this.config.marketAdj) || 0) / 100;
    var refUsd = parseFloat(String(this.config.refUsd || '').replace(/[^0-9.]/g, '')) || 0;
    var refLocal = (Number(this.config.refLocal) || 0) / 100;
    var sc = window.Shopify && window.Shopify.currency;
    var liveRate = sc && sc.active === this.currency ? parseFloat(sc.rate) : 0;
    if (this.isUSD) this.fx = 1;
    else if (liveRate > 0) this.fx = liveRate;
    else if (refUsd > 0 && refLocal > 0) this.fx = refLocal / (refUsd * adj);
    else this.fx = 1;
    this.digits = minorDigits(this.currency);
    this.tiers = (this.config.tiers || [])
      .map(function (t) { return { qty: parseInt(t.qty, 10) || 0, off: parseFloat(String(t.off).replace(/[^0-9.]/g, '')) || 0 }; })
      .filter(function (t) { return t.qty > 0; })
      .map(function (t) { var offLocal = roundMinor(t.off * self.fx, self.digits); return { qty: t.qty, off: t.off, offLocal: offLocal, price: roundMinor(self.basePrice - offLocal, self.digits) }; })
      .filter(function (t) { return t.price > 0; })
      .sort(function (a, b) { return a.qty - b.qty; });
    if (!this.tiers.length) this.tiers = [{ qty: 1, off: 0, offLocal: 0, price: this.basePrice }];
    this.maxTier = this.tiers[this.tiers.length - 1];
    this.longSymbol = money(1, this.currency).length > 5;
    this.sizes = (this.config.sizes || []).map(function (s) { return String(s).trim(); }).filter(Boolean);
    this.size = this.sizes.indexOf(this.config.defaultSize) >= 0 ? this.config.defaultSize : this.sizes[0];

    this.byId = {}; this.byVariant = {};
    this.products.forEach(function (p) {
      p.vBySize = {};
      p.variants.forEach(function (v) { p.vBySize[v.size] = v; self.byVariant[v.id] = { p: p, v: v }; });
      self.byId[p.id] = p;
    });

    // draft: ordered lines {vid, cid, size, qty}; cart: what Shopify holds for this product {vid: qty}
    this.draft = [];
    this.cartLines = {};
    this.cartOtherCount = 0;
    this.cartLoaded = false;
    var qs = null;
    try { qs = new URLSearchParams(window.location.search); } catch (e) {}
    this.preAdd = qs ? (parseInt(qs.get('add'), 10) || 0) : 0;
    this.goal = qs ? (parseInt(qs.get('goal'), 10) || 0) : 0;

    var $ = function (sel) { return self.querySelector(sel); };
    this.$price = $('[data-bb-price]'); this.$compare = $('[data-bb-compare]'); this.$count = $('[data-bb-count]');
    this.$segs = $('[data-bb-segs]'); this.$seglabels = $('[data-bb-seglabels]'); this.$nudge = $('[data-bb-nudge]');
    this.$whys = Array.prototype.slice.call(this.querySelectorAll('[data-bb-why]'));
    this.$sizes = $('[data-bb-sizes]'); this.$picked = $('[data-bb-picked]'); this.$grid = $('[data-bb-grid]');
    this.$total = $('[data-bb-total]'); this.$totline = $('[data-bb-totline]'); this.$checkout = $('[data-bb-checkout]');
    this.$bar = $('[data-bb-bar]'); this.$confirm = $('[data-bb-confirm]'); this.$toast = $('[data-bb-toast]');
    this.$mode = $('[data-bb-mode]'); this.$hero = $('[data-bb-hero]');

    this.buildSizes(); this.buildGrid(); this.buildBar();
    this.render();

    this.$checkout.addEventListener('click', function () { self.checkout(); });
    Array.prototype.forEach.call(this.querySelectorAll('[data-bb-leave]'), function (b) { b.addEventListener('click', function () { self.askLeave(); }); });
    Array.prototype.forEach.call(this.querySelectorAll('[data-bb-keep]'), function (b) { b.addEventListener('click', function () { self.closeLeave(); }); });
    $('[data-bb-go]').addEventListener('click', function () { self.leave(); });
    this.$leaveMsg = $('[data-bb-leave-msg]');
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !self.$confirm.hidden) self.closeLeave(); });

    this.loadCart();
  };

  /* ---------- cart ---------- */
  BundleBuilder2.prototype.loadCart = function () {
    var self = this;
    return fetch((this.routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        self.cartLines = {}; self.draft = []; var ours = 0;
        (cart.items || []).forEach(function (item) {
          var hit = self.byVariant[item.variant_id];
          if (!hit || item.product_id !== self.config.productId) return;
          self.cartLines[item.variant_id] = (self.cartLines[item.variant_id] || 0) + item.quantity;
          var line = self.draft.filter(function (l) { return l.vid === item.variant_id; })[0];
          if (line) { line.qty += item.quantity; line.base += item.quantity; }
          else self.draft.push({ vid: item.variant_id, cid: hit.p.id, size: hit.v.size, qty: item.quantity, base: item.quantity });
          ours += item.quantity;
        });
        self.cartOtherCount = Math.max(0, (cart.item_count || 0) - ours);
        if (self.draft.length && self.sizes.indexOf(self.draft[0].size) >= 0) self.size = self.draft[0].size;
        self.applyPreload();
        self.cartLoaded = true;
        self.render();
      })
      .catch(function (e) { console.warn('[bundle-builder-2] could not read the cart', e); self.cartLoaded = true; self.render(); });
  };
  /* Homepage hand-off: their shirt goes in the draft first, nothing is written to the cart. */
  BundleBuilder2.prototype.applyPreload = function () {
    if (this._preDone) return;
    this._preDone = true;
    var hit = this.preAdd ? this.byVariant[this.preAdd] : null;
    if (hit && hit.v.available) {
      var line = null;
      for (var i = 0; i < this.draft.length; i++) if (this.draft[i].vid === this.preAdd) { line = this.draft.splice(i, 1)[0]; break; }
      if (line) line.qty += 1;
      else line = { vid: this.preAdd, cid: hit.p.id, size: hit.v.size, qty: 1, base: 0 };
      this.draft.unshift(line);
      if (this.sizes.indexOf(hit.v.size) >= 0) this.size = hit.v.size;
      this.preloaded = hit.p.id;
    }
    if (this.preAdd || this.goal) {
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete('add'); u.searchParams.delete('goal');
        window.history.replaceState(window.history.state, '', u.pathname + (u.search || '') + u.hash);
      } catch (e) {}
    }
  };
  BundleBuilder2.prototype.draftMap = function () {
    var m = {};
    this.draft.forEach(function (l) { if (l.qty > 0) m[l.vid] = (m[l.vid] || 0) + l.qty; });
    return m;
  };
  BundleBuilder2.prototype.sameAsCart = function () {
    var d = this.draftMap(), c = this.cartLines, k;
    for (k in d) if (d[k] !== (c[k] || 0)) return false;
    for (k in c) if (c[k] !== (d[k] || 0)) return false;
    return true;
  };
  /* Checkout: make the cart's 2.0 lines match the draft, then open the cart page. */
  BundleBuilder2.prototype.checkout = function () {
    var self = this;
    if (this.busy || !this.draft.length) return;
    this.busy = true;
    var label = this.$checkout.textContent;
    this.$checkout.textContent = this.text.buttonBusy || label;
    this.$checkout.classList.add('is-busy');
    var d = this.draftMap(), updates = {}, adds = [], k, changed = false;
    for (k in this.cartLines) { if ((d[k] || 0) !== this.cartLines[k]) { updates[k] = d[k] || 0; changed = true; } }
    for (k in d) { if (!(k in this.cartLines)) { adds.push({ id: Number(k), quantity: d[k] }); changed = true; } }
    var chain = Promise.resolve();
    if (Object.keys(updates).length) chain = chain.then(function () { return postJSON((self.routes.cartUpdate || '/cart/update') + '.js', { updates: updates }); });
    if (adds.length) chain = chain.then(function () { return postJSON((self.routes.cartAdd || '/cart/add') + '.js', { items: adds }); });
    /* Fast Bundle applies Buy More Save More from the storefront after a cart change.
       Let it finish before leaving, so the cart page opens with the discount on it
       (capped at 4 seconds, and skipped if Fast Bundle is not on the page). */
    chain.then(function () {
      if (typeof window.detectBundleDiscounts !== 'function') return;
      var fb = Promise.resolve().then(function () { return window.detectBundleDiscounts(); }).catch(function () {});
      var cap = new Promise(function (r) { setTimeout(r, 4000); });
      return Promise.race([fb, cap]);
    }).then(function () {
      window.location.href = self.routes.checkout || '/checkout';
    }).catch(function (e) {
      console.error('[bundle-builder-2] cart write failed', e);
      self.toast(e && e.message && /stock|available|inventory/i.test(e.message) ? e.message : self.text.cartError);
      self.busy = false;
      self.$checkout.classList.remove('is-busy');
      self.loadCart();
    });
  };
  BundleBuilder2.prototype.askLeave = function () {
    if (this.sameAsCart()) { this.leave(); return; }
    // new shirts only: say how many; anything removed or resized: the general line
    var d = this.draftMap(), c = this.cartLines, added = 0, removed = 0, k;
    for (k in d) added += Math.max(0, d[k] - (c[k] || 0));
    for (k in c) removed += Math.max(0, c[k] - (d[k] || 0));
    var msg = this.text.leaveAsk;
    if (!removed && added === 1 && this.text.leaveOne) msg = this.text.leaveOne;
    else if (!removed && added > 1 && this.text.leaveMany) msg = fill(this.text.leaveMany, { count: added });
    if (this.$leaveMsg) this.$leaveMsg.textContent = msg;
    this._leaveFrom = document.activeElement;
    this.$confirm.hidden = false;
    document.documentElement.classList.add('bb-leave-open');
    var keep = this.$confirm.querySelector('.bb__leave-keep');
    if (keep) keep.focus();
  };
  BundleBuilder2.prototype.closeLeave = function () {
    this.$confirm.hidden = true;
    document.documentElement.classList.remove('bb-leave-open');
    if (this._leaveFrom && this._leaveFrom.focus) this._leaveFrom.focus();
  };
  /* Back to the page the shopper came from; the cart is untouched. */
  BundleBuilder2.prototype.leave = function () {
    var fallback = this.routes.fallback || this.routes.cart || '/cart';
    var ref = document.referrer || '';
    var sameSite = false;
    try { sameSite = !!ref && new URL(ref).origin === window.location.origin && new URL(ref).pathname !== window.location.pathname; } catch (e) {}
    if (sameSite && window.history.length > 1) window.history.back();
    else window.location.href = fallback;
  };

  /* ---------- derived ---------- */
  BundleBuilder2.prototype.variantFor = function (cid, size) { var p = this.byId[cid]; return p ? p.vBySize[size] : null; };
  BundleBuilder2.prototype.isAvailable = function (cid, size) { var v = this.variantFor(cid, size); return !!(v && v.available); };
  BundleBuilder2.prototype.countFor = function (cid) { return this.draft.filter(function (l) { return l.cid === cid; }).reduce(function (n, l) { return n + l.qty; }, 0); };
  BundleBuilder2.prototype.total = function () { return this.draft.reduce(function (n, l) { return n + l.qty; }, 0); };
  BundleBuilder2.prototype.tierFor = function (n) { var t = null; this.tiers.forEach(function (tier) { if (n >= tier.qty) t = tier; }); return t; };
  BundleBuilder2.prototype.nextTierFor = function (n) { return this.tiers.filter(function (t) { return t.qty > n; })[0] || null; };
  BundleBuilder2.prototype.stockRoom = function (cid, size) {
    var v = this.variantFor(cid, size);
    if (!v || !v.available) return 0;
    if (!v.managed || v.policy === 'continue') return Infinity;
    var inDraft = this.draft.filter(function (l) { return l.vid === v.id; }).reduce(function (n, l) { return n + l.qty; }, 0);
    return Math.max(0, v.qty - inDraft);
  };
  BundleBuilder2.prototype.sizesFor = function (cid) {
    return this.draft.filter(function (l) { return l.cid === cid && l.qty > 0; }).map(function (l) { return l.size + (l.qty > 1 ? '×' + l.qty : ''); }).join(' ');
  };

  /* ---------- build ---------- */
  BundleBuilder2.prototype.buildSizes = function () {
    var self = this;
    this.$sizes.innerHTML = '';
    this.sizes.forEach(function (s) {
      var b = el('button', 'bb__size', s); b.type = 'button'; b.dataset.size = s; b.setAttribute('role', 'radio');
      b.addEventListener('click', function () { self.setSize(s); });
      self.$sizes.appendChild(b);
    });
  };
  BundleBuilder2.prototype.buildGrid = function () {
    var self = this;
    this.$grid.innerHTML = '';
    this.products.forEach(function (p) {
      var t = el('div', 'bb__tile'); t.dataset.cid = p.id; t.setAttribute('role', 'button'); t.setAttribute('tabindex', '0'); t.setAttribute('aria-label', p.color);
      var img = el('img', 'bb__thumb'); img.src = p.image || ''; img.alt = ''; img.loading = 'lazy'; img.width = 120; img.height = 120;
      var minus = el('button', 'bb__minus', '&minus;'); minus.type = 'button'; minus.setAttribute('aria-label', 'Remove one ' + p.color);
      var badge = el('span', 'bb__badge', '0');
      t.append(img, minus, badge, el('span', 'bb__soldout', ''), el('span', 'bb__tname', p.color));
      t.addEventListener('click', function (e) { if (e.target === minus || e.target === badge) { self.removeOne(p.id); return; } self.addOne(p.id); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.addOne(p.id); }
        if (e.key === 'Backspace' || e.key === 'Delete') { e.preventDefault(); self.removeOne(p.id); }
      });
      self.$grid.appendChild(t);
    });
  };
  BundleBuilder2.prototype.buildBar = function () {
    var self = this;
    this.$segs.innerHTML = ''; this.$seglabels.innerHTML = '';
    this.tiers.forEach(function () { self.$segs.appendChild(el('i')); self.$seglabels.appendChild(el('span')); });
  };

  /* ---------- actions (draft only) ---------- */
  /* Shirts added here move to the new size; shirts from the cart (base) stay put. */
  BundleBuilder2.prototype.setSize = function (size) {
    if (this.sizes.indexOf(size) < 0 || size === this.size) return;
    var self = this, next = [];
    function put(vid, cid, sz, qty, base) {
      var hit = next.filter(function (m) { return m.vid === vid; })[0];
      if (hit) { hit.qty += qty; hit.base += base; } else next.push({ vid: vid, cid: cid, size: sz, qty: qty, base: base });
    }
    this.draft.forEach(function (l) {
      var base = Math.min(l.base || 0, l.qty), extra = l.qty - base;
      if (base > 0) put(l.vid, l.cid, l.size, base, base);
      if (extra > 0) { var v = self.variantFor(l.cid, size); if (v && v.available) put(v.id, l.cid, size, extra, 0); }
    });
    this.draft = next;
    this.size = size;
    this.render();
  };
  BundleBuilder2.prototype.addOne = function (cid) {
    var v = this.variantFor(cid, this.size);
    if (!v || !v.available) return;
    if (this.stockRoom(cid, this.size) <= 0) { this.toast(fill(this.text.onlyLeft, { count: v.qty, size: this.size })); return; }
    var line = this.draft.filter(function (l) { return l.vid === v.id; })[0];
    if (line) line.qty += 1; else this.draft.push({ vid: v.id, cid: cid, size: this.size, qty: 1, base: 0 });
    this.render();
  };
  BundleBuilder2.prototype.removeOne = function (cid) {
    for (var i = this.draft.length - 1; i >= 0; i--) {
      var l = this.draft[i];
      if (l.cid === cid && l.qty > 0) { l.qty -= 1; if ((l.base || 0) > l.qty) l.base = l.qty; if (l.qty === 0) this.draft.splice(i, 1); this.render(); return; }
    }
  };

  /* ---------- render ---------- */
  BundleBuilder2.prototype.render = function () {
    var self = this, cur = this.currency;
    var n = this.total(), tier = this.tierFor(n) || this.tiers[0], next = this.nextTierFor(n), price = tier.price;

    this.$price.textContent = money(price, cur);
    if (n > 0 && price < this.basePrice) { this.$compare.textContent = money(this.basePrice, cur); this.$compare.hidden = false; } else this.$compare.hidden = true;
    this.$count.textContent = n + ' ' + (n === 1 ? this.text.shirtOne : this.text.shirtMany);

    // goal from the homepage: light every step up to the goal's tier until the bundle reaches it
    var chasing = this.goal > 1 && n > 0 && n < this.goal;
    var goalTier = chasing ? this.tierFor(this.goal) : null;
    var pin = this.$segs.parentNode; if (pin) pin.classList.toggle('has-goal', !!chasing);
    var segs = this.$segs.children, labels = this.$seglabels.children;
    this.tiers.forEach(function (t, i) {
      var on = n >= t.qty, isNext = !chasing && next && t.qty === next.qty, isGoal = chasing && !on && t.qty <= goalTier.qty, isTarget = chasing && t.qty === goalTier.qty;
      segs[i].className = on ? 'on' : (isGoal ? 'goal' : (isNext ? 'next' : ''));
      labels[i].className = (on ? 'on' : (isTarget ? 'target' : (isNext ? 'next' : ''))) + (self.longSymbol && !on ? ' two' : '');
      if (isTarget) labels[i].setAttribute('data-tag', self.text.goalTag || ''); else labels[i].removeAttribute('data-tag');
      if (on) labels[i].textContent = String(t.qty);
      else if (self.longSymbol) labels[i].innerHTML = t.qty + '<br>' + money(t.price, cur);
      else labels[i].textContent = t.qty + ' · ' + money(t.price, cur);
    });

    var maxVars = { off: usd(this.maxTier.off), offLocal: money(this.maxTier.offLocal, cur), pct: pctOff(this.maxTier.price, this.basePrice) };
    this.$nudge.classList.toggle('is-live', n > 0);
    if (n === 0) {
      this.$nudge.innerHTML = fill(this.text.nudgeEmpty || '', maxVars);
      this.setWhy(fill(this.text.whyEmpty || '', maxVars));
    } else if (chasing) {
      var left = this.goal - n;
      var gTotal = roundMinor(this.goal * goalTier.price, this.digits);
      var gSaved = roundMinor(this.goal * this.basePrice - gTotal, this.digits);
      var gTpl = (n === 1 && this.preloaded && this.text.goalFirst) ? this.text.goalFirst : this.text.goalNext;
      this.$nudge.innerHTML = fill(gTpl, { color: this.preloaded ? this.byId[this.preloaded].color : '', count: '<b>' + left + '</b>', price: '<b>' + money(goalTier.price, cur) + '</b>' });
      var savedTxt = (this.isUSD && Number.isInteger(gSaved)) ? usd(gSaved) : money(gSaved, cur);
      this.setWhy(this.text.goalWhy ? fill(this.text.goalWhy, { goal: this.goal, total: money(gTotal, cur), saved: savedTxt }) : '');
    } else if (next) {
      var more = next.qty - n;
      var delta = roundMinor(next.qty * next.price - n * price, this.digits);
      var vars = { count: '<b>' + more + '</b>', price: '<b>' + money(next.price, cur) + '</b>', delta: '<b>' + money(Math.abs(delta), cur) + '</b>', off: usd(next.off), offLocal: money(next.offLocal, cur) };
      var tpl = this.text.nudgeNext;
      if (delta <= 0 && this.text.nudgeNextLess) tpl = this.text.nudgeNextLess;
      else if (delta / more < next.price / 2 && this.text.nudgeNextCheap) tpl = this.text.nudgeNextCheap;
      this.$nudge.innerHTML = fill(tpl, vars);
      var whyVars = { count: more, shirts: more === 1 ? this.text.shirtOne : this.text.shirtMany, pct: pctOff(next.price, this.basePrice), off: usd(next.off), offLocal: money(next.offLocal, cur), next: next.qty, now: n, delta: money(Math.abs(delta), cur) };
      var why = '';
      if (delta <= 0 && this.text.whyLess) why = this.text.whyLess;
      else if (delta / more < next.price / 4 && this.text.whyCheap) why = this.text.whyCheap;
      this.setWhy(why ? fill(why, whyVars) : '');
    } else {
      this.$nudge.innerHTML = fill(this.text.nudgeMax, { count: n, price: '<b>' + money(price, cur) + '</b>', off: usd(tier.off), offLocal: money(tier.offLocal, cur), pct: pctOff(price, this.basePrice) });
      this.setWhy('');
    }

    Array.prototype.forEach.call(this.$sizes.children, function (b) {
      var s = b.dataset.size, any = self.products.some(function (p) { return self.isAvailable(p.id, s); });
      b.classList.toggle('is-on', s === self.size); b.classList.toggle('is-off', !any);
      b.setAttribute('aria-checked', s === self.size ? 'true' : 'false'); b.disabled = !any;
    });

    Array.prototype.forEach.call(this.$grid.children, function (t) {
      var cid = t.dataset.cid, c = self.countFor(cid), off = !self.isAvailable(cid, self.size);
      t.classList.toggle('is-sel', c > 0); t.classList.toggle('is-off', off && c === 0);
      t.querySelector('.bb__badge').textContent = c;
      t.querySelector('.bb__soldout').textContent = off ? self.text.soldOut : '';
      var mixed = c > 0 && self.draft.some(function (l) { return l.cid === cid && l.qty > 0 && l.size !== self.size; });
      t.querySelector('.bb__tname').textContent = mixed ? self.sizesFor(cid) : self.byId[cid].color;
      t.setAttribute('aria-disabled', off && c === 0 ? 'true' : 'false');
    });
    this.$picked.textContent = n + ' ' + this.text.picked;

    // phone header: the real cart's count, not the draft's
    if (this.$mode) {
      var cartCount = Object.keys(this.cartLines).reduce(function (s, k) { return s + self.cartLines[k]; }, 0) + this.cartOtherCount;
      var line = cartCount === 0 ? this.text.modeEmpty : fill(this.text.modeItems, { count: cartCount, items: cartCount === 1 ? this.text.itemOne : this.text.itemMany });
      this.$mode.textContent = this.cartLoaded ? line + (this.text.modeNote ? ' · ' + this.text.modeNote : '') : '';
    }
    // hero photo: the first shirt in the draft, else the default color
    if (this.$hero) {
      var first = this.draft.length ? this.byId[this.draft[0].cid] : this.byId[this.config.defaultHero];
      if (first && first.image && this.$hero.dataset.color !== first.id) {
        this.$hero.src = first.image.replace(/width=300/, 'width=400'); this.$hero.dataset.color = first.id;
      }
    }

    var total = roundMinor(n * price, this.digits);
    this.$total.textContent = money(total, cur);
    if (n === 0) { this.$totline.textContent = ''; this.$checkout.textContent = this.text.buttonEmpty; this.$checkout.disabled = true; }
    else {
      this.$totline.innerHTML = n + ' × ' + money(price, cur) + (price < this.basePrice ? ' <s>' + money(this.basePrice, cur) + '</s>' : '');
      if (!this.busy) this.$checkout.textContent = fill(this.text.button, { count: n });
      this.$checkout.disabled = false;
    }
    this.dispatchEvent(new CustomEvent('bundle-builder:change', { bubbles: true, detail: { count: n, price: price, total: total, tier: tier } }));
  };
  BundleBuilder2.prototype.setWhy = function (text) {
    this.$whys.forEach(function (w) { if (!text) { w.hidden = true; w.innerHTML = ''; return; } w.innerHTML = '<mark>' + text + '</mark>'; w.hidden = false; });
  };
  BundleBuilder2.prototype.toast = function (msg) {
    var self = this;
    if (!msg) return;
    this.$toast.textContent = msg; this.$toast.hidden = false;
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(function () { self.$toast.hidden = true; }, 2600);
  };

  customElements.define('bundle-builder-2', BundleBuilder2);
})();
